export default {
  fields: {
    Title: { value: "Title" },
    Type: {
      fields: {
        Key: { value: "TestType" },
        Phrase: { value: "Test Type" },
      },
    },
    Link: { value: { href: "#" } },
    List: [],
  },
};
